import React, { useState, useEffect } from 'react';
import { Container, Row, Card, CardBody, Col } from 'reactstrap';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import t, { partial } from '../../util/translation/translation';
import moment from 'moment';
import GoalSponsorGameForm from './components/GoalSponsorGameForm';
import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon';

const GoalSponsorGameFormPage = () => {
  const { gameId, planId } = useParams();
  const [game, setGame] = useState(null);
  const [planScoreType, setPlanScoreType] = useState('goal');
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const p = partial('goalSponsor');
  const s = partial('shared');
  const getGame = async () => {
    setLoading(true);
    try {
      const resGame = await Api.goalSponsor.games.getGameById(gameId);
      setGame(resGame);
      setLoading(false);
    } catch (err) {
      toast.error(JSON.stringify(err));
      setLoading(false);
    }
  };

  const fetchPlanScoreType = async () => {
    try {
      const plan =
        await Api.goalSponsor.subscriptionPlans.getSubscriptionPlanById(planId);
      setPlanScoreType(plan.scoreType || 'goal');
    } catch (err) {
      // keep default 'goal' if fetch fails
    }
  };

  useEffect(() => {
    fetchPlanScoreType();
    if (gameId) {
      getGame();
    }
  }, [gameId, planId]);

  const onGameSubmit = async (values) => {
    const payload = {
      title: values.title,
      startDate: moment(values.startDate),
      goalCount: Number(values.goalCount),
      planId: planId,
    };

    setLoading(true);
    try {
      if (gameId) {
        await Api.goalSponsor.games.updateGame(gameId, payload);
      } else {
        await Api.goalSponsor.games.createGame(payload);
      }
      setLoading(false);
      toast.success(p('gameSaved'));
      history.replace(`/goal-sponsor/subscription-plans/edit/${planId}?tab=2`);
    } catch (err) {
      toast.error(err || s('somethingWentWrong'));
      setLoading(false);
    }
  };

  return (
    <Container>
      <Loading loading={loading} />
      <Row>
        <Col>
          <Card>
            <CardBody>
              <GoalSponsorGameForm
                type={gameId ? 'edit' : 'create'}
                game={game}
                onSubmit={onGameSubmit}
                planId={planId}
                planScoreType={planScoreType}
              />
              <Col>
                <div className="mb-2 d-flex align-items-center border p-3">
                  <div className="modal-icon mr-4">
                    <AlertCircleOutlineIcon size="38" />
                  </div>
                  <div className="d-flex flex-column">
                    <p>
                      Transactions with user will be made approx 1 day after a
                      game is created
                    </p>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default GoalSponsorGameFormPage;
